import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const benefits = [{
  title: 'Más concentración',
  desc: 'Aprendé a mantener el foco durante cada kilómetro sin que los pensamientos negativos tomen el control.'
}, {
  title: 'Mejor gestión del esfuerzo',
  desc: 'Aprendé a convivir con la incomodidad sin entrar en pánico cuando el cuerpo empieza a exigir más.'
}, {
  title: 'Disfrutar más correr',
  desc: 'Dejá de obsesionarte con el reloj y volvé a conectar con el placer de correr.'
}, {
  title: 'Mejor rendimiento',
  desc: 'Cuando entrenás tu mente, aprovechás mucho mejor todo el entrenamiento físico que ya hacés.'
}];
export function Benefits() {
  return <section id="beneficios" className="py-8 px-4 md:px-8 bg-sage-soft" data-id="element-9">
      <div className="max-w-5xl mx-auto" data-id="element-10">
        <div className="text-center mb-6" data-id="element-11">
          <h2 className="font-display font-bold text-3xl md:text-5xl text-ink" data-id="element-12">
            Lo que vas a lograr con Mindfulness para Runners
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-13">
          {benefits.map((benefit, idx) => <div key={idx} className={`bg-white rounded-2xl p-8 shadow-sm border border-sage/20 flex gap-4 ${idx === benefits.length - 1 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-14">
              <div className="flex-shrink-0 mt-1" data-id="element-15">
                <CheckCircle2 className="w-6 h-6 text-forest" data-id="element-16" />
              </div>
              <div data-id="element-17">
                <h3 className="font-display font-bold text-xl text-ink mb-2" data-id="element-18">
                  {benefit.title}
                </h3>
                <p className="text-ink/70 leading-relaxed" data-id="element-19">{benefit.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}